<div
  class="number-field"
  [ngClass]="{
    'has-value': internalFormControl.value !== null,
    condensed: !placeholder
  }"
>
  <label
    class="number-label field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: formControl?.disabled
    }"
    [attr.for]="fieldId"
    type="text"
  >
    {{ label }}
  </label>

  <div class="number-wrapper">
    <input
      class="number-input"
      type="text"
      focusable
      tabindex="0"
      [attr.data-e2e-id]="e2eId"
      [formatAsNumber]="formatAsNumberOptions"
      [attr.id]="fieldId"
      [attr.placeholder]="placeholder"
      [value]="initialValue"
      [formControl]="internalFormControl"
      (onBlur)="onBlur.emit()"
      (onFocus)="onFocus.emit()"
    />

    <app-error-message
      [fieldControl]="formControl"
      [errorMessage]="errorMessage"
    >
    </app-error-message>
  </div>
</div>
